(function () {
  const root = document.querySelector('[data-saloa-quick-add-lite]');
  if (!root) return;

  const state = {
    product: null,
    selectedOptions: [],
    selectedVariantId: null,
    productUrl: '#',
    cache: new Map(),
  };

  const selectors = {
    image: '[data-saloa-quick-add-image]',
    thumbs: '[data-saloa-quick-add-thumbs]',
    title: '[data-saloa-quick-add-title]',
    price: '[data-saloa-quick-add-price]',
    options: '[data-saloa-quick-add-options]',
    form: '[data-saloa-quick-add-form]',
    variantId: '[data-saloa-quick-add-variant-id]',
    details: '[data-saloa-quick-add-details]',
  };

  function getElement(selector) {
    return root.querySelector(selector);
  }

  function requestJson(url, options = {}) {
    if (typeof window.fetch === 'function') {
      return fetch(url, options).then((response) => {
        if (!response.ok) throw new Error('Request failed');
        return response.json();
      });
    }

    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(options.method || 'GET', url, true);
      Object.entries(options.headers || {}).forEach(([name, value]) => {
        request.setRequestHeader(name, value);
      });
      request.onload = function () {
        if (request.status < 200 || request.status >= 300) {
          reject(new Error('Request failed'));
          return;
        }

        try {
          resolve(JSON.parse(request.responseText));
        } catch (error) {
          reject(error);
        }
      };
      request.onerror = function () {
        reject(new Error('Request failed'));
      };
      request.send(options.body || null);
    });
  }

  function getCartDrawer() {
    return document.getElementById('CartDrawer');
  }

  function getSectionsToRender() {
    if (window.xCartHelper && typeof window.xCartHelper.getSectionsToRender === 'function') {
      const sectionId = getCartDrawer()?.dataset.sectionId;
      return window.xCartHelper.getSectionsToRender(sectionId);
    }

    return [
      {id: 'cart-icon-bubble', selector: '#cart-icon-bubble'},
    ];
  }

  function renderSection(html, selector) {
    const target = document.querySelector(selector);
    if (!target || !html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.querySelector(selector);
    if (replacement) target.innerHTML = replacement.innerHTML;
  }

  function openCartDrawer() {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;

    cartDrawer.isOpen = true;
    cartDrawer.setAttribute('open', '');
    document.getElementById('CartDrawer__Wrapper')?.classList.add('is-visible');
  }

  function addItemFallback(item) {
    const sectionsToRender = getSectionsToRender();
    const sections = sectionsToRender.map((section) => section.id).filter(Boolean);

    return requestJson(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: [item], sections}),
    }).then((response) => {
      if (response.sections) {
        sectionsToRender.forEach((section) => {
          renderSection(response.sections[section.id], section.selector);
        });
      }

      if (window.xCartHelper && typeof window.xCartHelper.updateCurrentCountItem === 'function') {
        window.xCartHelper.updateCurrentCountItem();
      }

      if (window.CART_EVENT?.cartUpdate) {
        document.dispatchEvent(new CustomEvent(window.CART_EVENT.cartUpdate, {detail: {openMiniCart: true}}));
      }

      openCartDrawer();
      document.dispatchEvent(new CustomEvent('saloa:lite-cart:add', {detail: {item}}));
    });
  }

  function addQuickItem(item) {
    if (typeof window.SaloaLiteCart?.addItem === 'function') {
      return window.SaloaLiteCart.addItem(item);
    }

    return addItemFallback(item);
  }

  function normalizeImage(src) {
    if (!src) return '';
    if (src.startsWith('//')) return `${window.location.protocol}${src}`;
    return src;
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'es-ES';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
    }
  }

  function getVariantOptions(variant) {
    if (Array.isArray(variant?.options) && variant.options.length) return variant.options.filter(Boolean);
    return [variant?.option1, variant?.option2, variant?.option3].filter(Boolean);
  }

  function getProductOptions(product) {
    const variants = product.variants || [];
    const onlyDefaultVariant = variants.length === 1 && getVariantOptions(variants[0]).join(' / ') === 'Default Title';
    if (onlyDefaultVariant) return [];

    return (product.options || []).map((option, index) => ({
      name: typeof option === 'string' ? option : option.name || `Option ${index + 1}`,
      position: index,
    }));
  }

  function findVariant() {
    if (!state.product) return null;
    return state.product.variants.find((variant) => {
      const options = getVariantOptions(variant);
      return state.selectedOptions.every((value, index) => options[index] === value);
    }) || null;
  }

  function findCurrentOrFirstAvailableVariant() {
    if (!state.product) return null;
    return findVariant()
      || state.product.variants.find((variant) => Number(variant.id) === Number(state.selectedVariantId))
      || findFirstAvailableVariant(state.product);
  }

  function findFirstAvailableVariant(product) {
    return product.variants.find((variant) => variant.available) || product.variants[0] || null;
  }

  function updateMainImage(src) {
    const image = getElement(selectors.image);
    const nextSrc = normalizeImage(src);
    if (!image || !nextSrc) return;
    image.src = nextSrc;
    image.alt = state.product?.title || '';

    getElement(selectors.thumbs)?.querySelectorAll('button').forEach((button) => {
      button.classList.toggle('is-active', normalizeImage(button.dataset.image) === nextSrc);
    });
  }

  function renderThumbs(product, selectedVariant) {
    const thumbs = getElement(selectors.thumbs);
    if (!thumbs) return;

    const urls = [];
    const pushUnique = (src) => {
      const normalized = normalizeImage(src);
      if (normalized && !urls.includes(normalized)) urls.push(normalized);
    };

    pushUnique(selectedVariant?.featured_image?.src);
    pushUnique(product.featured_image);
    (product.images || []).forEach(pushUnique);

    thumbs.innerHTML = urls.slice(0, 5).map((src, index) => `
      <button type="button" class="${index === 0 ? 'is-active' : ''}" data-image="${src}" aria-label="Imagen ${index + 1}">
        <img src="${src}" alt="">
      </button>
    `).join('');
  }

  function optionWouldBeAvailable(position, value) {
    const options = state.selectedOptions.slice();
    options[position] = value;

    return state.product.variants.some((variant) => {
      if (!variant.available) return false;
      const variantOptions = getVariantOptions(variant);
      return options.every((optionValue, index) => !optionValue || variantOptions[index] === optionValue);
    });
  }

  function renderOptions() {
    const optionsRoot = getElement(selectors.options);
    if (!optionsRoot || !state.product) return;

    const html = getProductOptions(state.product).map((option) => {
      const position = option.position;
      const values = [...new Set(state.product.variants.map((variant) => getVariantOptions(variant)[position]).filter(Boolean))];
      const buttons = values.map((value) => {
        const active = state.selectedOptions[position] === value;
        const available = optionWouldBeAvailable(position, value);
        return `
          <button
            type="button"
            class="${active ? 'is-active' : ''}"
            data-option-position="${position}"
            data-option-value="${String(value).replace(/"/g, '&quot;')}"
            ${available ? '' : 'disabled'}
          >${value}</button>
        `;
      }).join('');

      return `
        <fieldset>
          <legend>${option.name}: <span>${state.selectedOptions[position] || ''}</span></legend>
          <div>${buttons}</div>
        </fieldset>
      `;
    }).join('');

    optionsRoot.innerHTML = html;
  }

  function updateVariant() {
    const variant = findCurrentOrFirstAvailableVariant();
    const submit = root.querySelector('.saloa-quick-add-lite__submit');
    const variantInput = getElement(selectors.variantId);

    state.selectedVariantId = variant?.id || null;
    if (variantInput) variantInput.value = variant?.id || '';
    if (submit) {
      submit.disabled = !variant?.available;
      submit.textContent = variant?.available ? 'Añadir al carrito' : 'Agotado';
    }

    getElement(selectors.price).textContent = variant ? formatMoney(variant.price) : '';
    if (variant?.featured_image?.src) updateMainImage(variant.featured_image.src);
    renderOptions();
  }

  function openDialog() {
    root.hidden = false;
    root.classList.add('is-open');
    document.documentElement.classList.add('saloa-quick-add-lite-lock');
    root.querySelector('.saloa-quick-add-lite__close')?.focus();
  }

  function closeDialog() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('saloa-quick-add-lite-lock');
    window.setTimeout(() => {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 180);
  }

  function populate(product, productUrl) {
    const variant = findFirstAvailableVariant(product);
    state.product = product;
    state.productUrl = productUrl || product.url || '#';
    state.selectedOptions = variant ? getVariantOptions(variant) : [];
    state.selectedVariantId = variant?.id || null;

    getElement(selectors.title).textContent = product.title || '';
    getElement(selectors.details).href = state.productUrl;
    const variantInput = getElement(selectors.variantId);
    if (variantInput) variantInput.value = state.selectedVariantId || '';
    renderThumbs(product, variant);
    updateMainImage(variant?.featured_image?.src || product.featured_image || product.images?.[0]);
    renderOptions();
    updateVariant();
    openDialog();
  }

  function loadProduct(handle) {
    if (state.cache.has(handle)) return Promise.resolve(state.cache.get(handle));

    return requestJson(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`, {
      headers: {Accept: 'application/json'},
    }).then((product) => {
      state.cache.set(handle, product);
      return product;
    });
  }

  document.addEventListener('click', function (event) {
    const directTrigger = event.target.closest('[data-saloa-quick-add-variant]');
    if (directTrigger) {
      event.preventDefault();
      const variantId = Number(directTrigger.dataset.saloaQuickAddVariant);

      if (!variantId) {
        if (directTrigger.dataset.saloaQuickAddUrl) window.location.href = directTrigger.dataset.saloaQuickAddUrl;
        return;
      }

      directTrigger.classList.add('is-loading');
      addQuickItem({id: variantId, quantity: 1})
        .catch(() => {
          if (directTrigger.dataset.saloaQuickAddUrl) window.location.href = directTrigger.dataset.saloaQuickAddUrl;
        })
        .finally(() => directTrigger.classList.remove('is-loading'));
      return;
    }

    const trigger = event.target.closest('[data-saloa-quick-add-handle]');
    if (!trigger) return;

    event.preventDefault();
    const handle = trigger.dataset.saloaQuickAddHandle;
    if (!handle) return;

    trigger.classList.add('is-loading');
    loadProduct(handle)
      .then((product) => populate(product, trigger.dataset.saloaQuickAddUrl))
      .catch(() => {
        if (trigger.dataset.saloaQuickAddUrl) window.location.href = trigger.dataset.saloaQuickAddUrl;
      })
      .finally(() => trigger.classList.remove('is-loading'));
  });

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-saloa-quick-add-close]')) closeDialog();

    const thumb = event.target.closest('[data-image]');
    if (thumb) updateMainImage(thumb.dataset.image);

    const option = event.target.closest('[data-option-position]');
    if (option) {
      state.selectedOptions[Number(option.dataset.optionPosition)] = option.dataset.optionValue;
      updateVariant();
    }

    if (event.target.closest('[data-saloa-quick-add-qty-minus], [data-saloa-quick-add-qty-plus]')) {
      const input = root.querySelector('[name="quantity"]');
      const delta = event.target.closest('[data-saloa-quick-add-qty-plus]') ? 1 : -1;
      input.value = Math.max(1, Number(input.value || 1) + delta);
    }
  });

  root.addEventListener('submit', function (event) {
    const form = event.target.closest(selectors.form);
    if (!form) return;

    event.preventDefault();
    if (!state.selectedVariantId) {
      const fallbackVariant = findCurrentOrFirstAvailableVariant();
      state.selectedVariantId = fallbackVariant?.id || Number(getElement(selectors.variantId)?.value) || null;
      if (!state.selectedVariantId) {
        if (state.productUrl) window.location.href = state.productUrl;
        return;
      }
    }

    const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;

    addQuickItem({id: Number(state.selectedVariantId), quantity})
      .catch(() => {
        if (state.productUrl) window.location.href = state.productUrl;
      })
      .finally(() => {
        if (submit) submit.disabled = false;
      });
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) closeDialog();
  });

  document.addEventListener('saloa:lite-cart:add', closeDialog);
})();
